export default "__VITE_ASSET__700dbc79__"